var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/**
 * API service for the semantic catalog — the local ontology (ADR-0007,
 * CZNA-419 / WP-P6a). The outgoing Semantic Component Registry's own service
 * module is retired (CZNA-433); {@link fetchComponentBindings} below is its
 * replacement for the derivation-rule componentType picker.
 */
import { getHeaders } from './apiUtils';
import { API_PATHS } from '../types/apiPaths';
/** The full ontology: `{ _meta, classes, classDerivation, properties, marc21Fields }`. */
export var fetchSemanticCatalog = function (ky) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, ky
                .get(API_PATHS.CZNA_SEMANTIC_CATALOG, { headers: getHeaders() })
                .json()];
    });
}); };
/**
 * Label-propagation trace for one MARC tag: the same name as the ontology declares
 * it and as the derived MARC catalog exposes it, per field and per subfield. The
 * point is that agreement is *shown*, not claimed.
 */
export var fetchSemanticCatalogTrace = function (ky, tag) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, ky
                .get(API_PATHS.CZNA_SEMANTIC_CATALOG, {
                searchParams: { view: 'trace', tag: tag },
                headers: getHeaders(),
            })
                .json()];
    });
}); };
/**
 * The same trace for every MARC tag at once, as per-tag counts (CZNA-547) — what
 * lets the fields list say WHERE a name is not right instead of making the reader
 * open all of them.
 */
export var fetchSemanticCatalogTraceSummary = function (ky) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, ky
                .get(API_PATHS.CZNA_SEMANTIC_CATALOG, {
                searchParams: { view: 'traceSummary' },
                headers: getHeaders(),
            })
                .json()];
    });
}); };
/**
 * Enum-backed `(tag, subfield) -> componentType` bindings (CZNA-433) — the
 * source for the derivation-rule componentType picker. See {@link
 * ComponentBindingsResponse} for why this is a restricted subset, not the
 * full `binds` view.
 */
export var fetchComponentBindings = function (ky) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, ky
                .get(API_PATHS.CZNA_SEMANTIC_CATALOG, {
                searchParams: { view: 'componentBindings' },
                headers: getHeaders(),
            })
                .json()];
    });
}); };
